<template>
  <div class="bid-column">
    <div v-if="!isEditing">
      ${{ parseFloat(params.data.bid).toFixed(3) }}
      <vs-icon v-if="canEdit" class="ml-1 cursor-pointer" @click="isEditing=true" icon="speakol-edit" icon-pack="speakol"></vs-icon>
    </div>
    <div class="flex py-2" v-else>
      <vx-input-group>
        <template slot="prepend">
          <div class="prepend-text dollar-sign dollar-sign-adset">
            <span>$</span>
          </div>
        </template>
        <div class="vx-input-group-default flex-grow">
          <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
            <div class="vs-con-input">
              <input class="vs-inputx vs-input--input vs-input-adset" min="0" type="number" @input="setNewBid($event)" :value="params.data.bid">
            </div>
            <span></span>
          </div>
        </div>
      </vx-input-group>
      <vs-icon class="save-new-cpm pt-4 mx-2" @click="updateAdsetContentCategoryBidding()" icon="speakol-save" icon-pack="speakol"></vs-icon>
      <vs-icon class="cancel-new-cpm pt-4" @click="isEditing=false" icon="speakol-cancel" icon-pack="speakol"></vs-icon>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isEditing: false,
      newbid: null
    }
  },
  beforeMount () {
    this.newbid = this.params.data.bid
  },

  computed: {
    canEdit () {
      return this.params.context.parent.canEditBid && this.params.data.status === this.$constants.ADSET_CONTENT_CATEGORY_STATUS.ACTIVE
    }
  },

  methods: {
    setNewBid (e) {
      // validate and format the cost_per_action value
      const value = parseFloat(e.target.value)

      if (Number.isNaN(value)) {
        this.newbid = null
        return
      }

      if (value < 0) {
        return
      }

      if (value > 9999.999) {
        alert('The value should be less than  9999.999')
        return
      }

      const fraction = value.toString().split('.')[1] || ''

      if (fraction.length > 3) {
        alert('The Decimals should be up to 3 digits')
        this.newbid = value.toFixed(3)
        return
      }

      this.newbid = value
    },

    async updateAdsetContentCategoryBidding () {
      try {
        const response = await window.axios.patch(`/campaigns/adset-content-categories/${this.params.data.id}`, {
          'bid_price': this.newbid,
          'adset_id': this.params.data.adset_id,
          'status': this.params.data.status,
          'content_category_id': this.params.data.content_category_id
        })

        if (response.status === 200) {
          this.isEditing = false

          // set the new bid
          this.params.node.setData({
            ...this.params.node.data,
            bid: this.newbid,
            id: response.data.payload.id
          })

          this.$nextTick(() => {
            this.params.api.refreshCells({
              rowNodes: [this.params.node],
              force: true
            })
          })

          this.$parent.$parent.$parent.$emit('modal-updated', {
            type: 'success',
            show: true,
            body: `Content Category "${this.params.data.category_name}" bidding updated to $${parseFloat(this.newbid).toFixed(3)}`
          })
        }
      } catch (error) {
        this.$parent.$parent.$parent.$emit('modal-updated', {
          type: 'error',
          show: true,
          body: error.response.data.errors.bid_price.join(', ')
        })
      }
    }
  }
}
</script>

<style lang='scss'>
  .bid-column {
    .dollar-sign {
      margin-top: 0 !important;
      height: 37.59px;
    }
  }

  .number-input {
    margin-top: 14% !important;
  }

  // .save-new-cpm,
  // .cancel-new-cpm {
  //   height: 39px;
  //   margin-top: 9px;
  // }

  .cursor-pointer {
    font-size: 15px !important;
  }
</style>
